const LoginFromType = {
  ADMIN: 1,
  CUSTOMER: 2
}
export default LoginFromType
